let marketingInitialized = false;

export function syncMarketingTechnologies({
  consentRequired,
  marketingGranted,
  initialize = typeof window !== 'undefined'
    ? window.__IMGA_INIT_MARKETING__
    : null,
}) {
  if (marketingInitialized || consentRequired || !marketingGranted) {
    return false;
  }
  if (typeof initialize !== 'function') {
    return false;
  }

  initialize();
  marketingInitialized = true;
  return true;
}

export function resetMarketingConsentForTests() {
  marketingInitialized = false;
}
